import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'
import { AlarmDefinitionGroupRowController } from './alarm-definition-group-row.controller'

//#region Asset Imports

import * as TEMPLATE from './alarm-definition-group-row.tpl.html'
import './alarm-definition-group-row.scss'

//#endregion


// #region Consts

export const COMPONENT_NAME: string = 'alarmDefinitionGroupRow'

// #endregion

export class AlarmDefinitionGroupRowComponent {

    controller = [
        USER_SESSION_SERVICE_NAME,
        (
            userSessionService: UserSessionService
        ) => {
            return new AlarmDefinitionGroupRowController(userSessionService)
        }
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}
